import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/soul";
import { toast } from "sonner";
import { SpeakButton } from "@/components/SpeakButton";
import { Trash2, MessageCircleHeart } from "lucide-react";

export default function SpokenWords() {
  const [items, setItems] = useState([]);

  const load = useCallback(() => {
    api.get("/spoken").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const remove = async (id) => {
    try {
      await api.delete(`/spoken/${id}`);
      toast.success("Removed.");
      load();
    } catch {
      toast.error("Could not remove.");
    }
  };

  return (
    <main data-testid="spoken-page" className="max-w-4xl mx-auto px-6 py-16">
      <div className="max-w-3xl mb-12 fade-up">
        <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-4 flex items-center gap-2">
          <MessageCircleHeart size={14} /> My Spoken Words
        </p>
        <h1 className="serif text-4xl sm:text-6xl font-light text-[#F5F1E7]">
          The words you've <span className="italic-serif text-[#D4AF37]">spoken over yourself</span>
        </h1>
        <p className="mt-5 text-[#A8A29E] leading-relaxed text-lg">
          Return to these. Speak them again. What you repeat, you build.
        </p>
      </div>

      {items.length === 0 ? (
        <div className="glass rounded-2xl p-12 text-[#A8A29E]">
          <p className="italic-serif text-xl">You haven't spoken any words yet.</p>
          <Link to="/roots" className="mt-4 inline-block text-[#D4AF37] hover:underline">
            Speak a root over yourself →
          </Link>
        </div>
      ) : (
        <div className="space-y-4" data-testid="spoken-list">
          {items.map((s) => (
            <div key={s.id} data-testid="spoken-item" className="glass rounded-2xl p-6 flex items-start justify-between gap-4">
              <div className="flex-1">
                <p className="italic-serif text-xl text-[#F5F1E7] leading-relaxed">“{s.text}”</p>
                {s.word && <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[#D4AF37]">{s.word}</p>}
                <div className="mt-4">
                  <SpeakButton text={s.text} label="Speak it again" />
                </div>
              </div>
              <button
                data-testid={`spoken-delete-${s.id}`}
                onClick={() => remove(s.id)}
                className="text-[#A8A29E] hover:text-[#C1272D] transition-colors duration-300"
              >
                <Trash2 size={16} />
              </button>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}
